export default "__VITE_ASSET__147617a7__"